'use client'
import { FC, useState, useRef } from "react";
import { Content } from "@prismicio/client";
import { SliceComponentProps, PrismicRichText } from "@prismicio/react";
import { PrismicNextImage } from '@prismicio/next'
import NextLink from 'next/link'
import Chevron from '@/assets/images/icons/icon-chevron-down.svg'

/**
 * Props for `NewsFilterAndListing`.
 */
export type NewsFilterAndListingProps =
  SliceComponentProps<Content.NewsFilterAndListingSlice>;

/**
 * Component for "NewsFilterAndListing" Slices.
 */
const NewsFilterAndListing: FC<NewsFilterAndListingProps> = ({ slice, context }) => {

  const formatDDMMYY = (value: string) => {
    const date = new Date(value);
    const dd = String(date.getDate()).padStart(2, '0');
    const mm = String(date.getMonth() + 1).padStart(2, '0');
    const yy = String(date.getFullYear()).slice(-2);
    return `${dd}/${mm}/${yy}`;
  }

  const contextData = context as any

  const [newsList] = useState(contextData?.articles) as any
  const buttonRef = useRef(null) as any

  const showAll =() => {
    const related = document.querySelector(".news-filter-listing") as any
    const matches = related.querySelectorAll(".hidden");
    buttonRef.current.style="display: none"
    if(matches && matches.length > 0) {
      for(let i=0; i<matches.length; i++){   
        matches[i].classList.remove("hidden")
      }
    }
  }

  let counter = 0;

  return (
    <section
      data-slice-type={slice.slice_type}
      data-slice-variation={slice.variation}
      className="px-4 md:px-8 lg:px-12 font-fellix text-jade"
    >
    <>
      <div className="bg-lightgrey max-w-[1280px] mx-auto">
        <PrismicNextImage field ={newsList[0].data.article_image} fallbackAlt="" sizes="100vw" priority/>
        <div className="p-8 md:p-12 lg:p-16 max-w-[850px] text-center mx-auto">
        <article className="text-[24px] leading-[28px] md:text-[28px] md:leading-[36px] font-semibold">
          <PrismicRichText field={newsList[0].data.article_title}/>
        </article>
        <article className="text-[18px] leading-[24px] md:text-[28px] md:leading-[36px] font-normal text-center mt-8 mb-16">
          <PrismicRichText field={newsList[0].data.article_tile_intro}/>
        </article>
        <NextLink className="button" href={"/articles/"+newsList[0]?.uid} aria-label={`Read more about ${newsList[0]?.data?.article_title?.[0]?.text ?? 'this article'}`}>
          Read more
        </NextLink>
        </div>
      </div>
      <div className="max-w-[1280px] mx-auto">
        <article className="text-center my-20">
          <PrismicRichText field={slice.primary.list_title} />
        </article>
        <div className="grid grid-cols-12 gap-0 md:gap-6 news-filter-listing">
          {newsList.map((item: any, index: number)=>{
            let show = true;
            item.tags.map((item: any)=>{
                if(item === "Informer Library") {
                  show = false;
                  counter--;
                }
            })
            counter++;
            if(index !==0 && show === true) {
              return (
                <div className={`${counter < 8 ? "col-span-12 md:col-span-6 lg:col-span-4" : "col-span-12 md:col-span-6 lg:col-span-4 hidden"} flex-col h-full relative`} key={index}>
                  <PrismicNextImage field ={item.data.article_thumb} className="w-full object-cover aspect-4/3" fallbackAlt="" sizes="(min-width: 1024px) 33vw, (min-width: 768px) 50vw, 100vw"/>
                  <div className="grid grid-cols-12 mt-4 mb-4 ">
                    <div className="col-span-8 md:col-span-9 text-[18px] font-semibold leading-[24px]">
                        <PrismicRichText field={item.data.article_title}/>
                    </div>
                    <div className="col-span-4 md:col-span-3 flex justify-end ">
                      {formatDDMMYY(item.data.publish_date)}
                    </div>
                  </div>
                  <div className="pb-24 md:pb-16">
                    <PrismicRichText field={item.data.article_tile_intro}/>
                    <div className="my-4 prose prose-a:text-blue-500 prose-a:no-underline absolute bottom-4 md:bottom-0">
                      <NextLink href={"/articles/"+item.uid} aria-label={`Read more about ${item.data?.article_title?.[0]?.text ?? 'this article'}`}>
                        <span className="inline-block">Read more</span>
                        <Chevron className="inline-block ml-2 stroke-blue-500 w-[20px] rotate-270 relative -top-[3px]"/>
                      </NextLink>
                    </div>
                  </div>
                </div>
              )
            }
            return null
          })}
                  </div>
      </div>
      </>
      <div className="w-full text-center py-16 " ref={buttonRef}><button className="text-[18px] leading-[19px] text-center pt-[16px] px-[32px] pb-[18px] rounded-full outline-none bg-transparent border-[1px] border-solid border-jade text-jade w-auto inline mx-auto my-0 cursor-pointer" onClick={()=>showAll()}>See more</button></div>

    </section>
  );
};

export default NewsFilterAndListing;
